import React, {useState} from 'react';
import styles from "../styles/standings-widget.module.scss";
import classNames from "classnames";
import {GAMES_SUGGESTIONS} from "../../games-suggestions-widget/games-suggestions-widget.consts";
import {GamesSuggestionsWidgetAsync} from "../../games-suggestions-widget/components/games-suggestions-widget.async";

export const StandingsWidgetGamesSuggestions = ({controller}) => {
  const {state} = controller;
  const {device: {isSmallView}, isWidget, isCollapsed, props: {competitionIds, isPreviewStandings}} = state;
  const [isWidgetVisible, setWidgetVisible] = useState(!isPreviewStandings && !isCollapsed && !isWidget && isSmallView);

  const onWidgetVisible = (isVisible) => {
    setWidgetVisible(isVisible);
  }

  const widgetProps = {
    competitionId: competitionIds,
    context: GAMES_SUGGESTIONS.CONTEXTS.competition,
    onWidgetVisible
  }

  return (
    isWidgetVisible ? <div className={classNames(styles.games_suggestions_container)}>
      <GamesSuggestionsWidgetAsync {...widgetProps}/>
    </div> : null
  )
};
